// extracted by mini-css-extract-plugin
module.exports = {"searchIcon":"PUWVinLookup-hashed__searchIcon__BCsb6","buttonBgColor":"PUWVinLookup-hashed__buttonBgColor___azHf","buttonPosition":"PUWVinLookup-hashed__buttonPosition__3sCtc"};